module.exports = __webpack_public_path__ + "img/emergency-alert.a206a224.png";